/**
 *
 * 员工选择器
 *
 *
 */
'use strict'

import Vue from 'vue';
import Component from "vue-class-component";
import { iStorage } from 'smart-core-util';

@Component
class costCenterSelector extends Vue {

	costCenterList = [];
	costList = [];
	codeList = [];
	costCenter = '';
	tableLoading = false;
	noData = false

	async created() {

	}
	async getCostCenter(obj) {
		if(obj && obj.type == 'web'){
			// 搜索后台做时放开限制
			this.pageIndex = obj.pageIndex - 1 || 0;
			this.pageSize = obj.pageSize || 10;
		}
		let params = {
			pageIndex: this.pageIndex,
			pageSize: this.pageSize,
			key: this.keyword,
			legalEntity: this.legalEntity
		};
		if(this.companyCode){
			params.companyCode = this.companyCode
		}
		this.tableLoading = true
		let response = await this.api.get(this.url.dictionary.gostCenterPagingA1, {params: params});
		this.tableLoading = false
		this.noData = false
		if(response && response.success) {
			if(obj && obj.type == 'web') {
				this.costList = response.content.Data;
				this.total = response.content.TotalCount;
				return false
			}
			if(this.pageIndex == 0) {
				this.costCenterList = [];
			}
			this.costCenterList = this.costCenterList.concat(response.content.Data);
			if(this.costCenterList.length == response.content.TotalCount) {
				this.allLoaded = true;
			}
			if (!response.content.Data.length) {
				this.noData = true
			}
			this.selected();
		}
	}
	async getWBSCode(obj, costCenter) {
		if(obj && obj.type == 'web'){
			this.costCenter = obj.costCenter || this.costCenter || '';
			this.keyword = obj.keyword || ''
			// 搜索后台做时放开限制
			this.pageIndex = obj.pageIndex - 1 || 0;
			this.pageSize = obj.pageSize || 10;
		}else{
			this.costCenter = this.$store.state.costForm.costCenter
		}
		if (costCenter) {
			this.costCenter = costCenter
		}
		let params = {
			pageIndex: this.pageIndex,
			pageSize: this.pageSize,
			costCenter: this.costCenter,
			key: this.keyword,
			legalEntity: this.legalEntity
		};
		if(this.companyCode){
			params.companyCode = this.companyCode
		}
		this.tableLoading = true
		let response = await this.api.get(this.url.dictionary.gostWbsPagingA1, {params: params});
		this.tableLoading = false
		this.noData = false
		if(response && response.success) {
			if (['Product Development'].includes(iStorage.get("dept")) && this.pageIndex === 0 && response.content.Data.length) {
				response.content.Data = [{wbselement: '空'}, ...response.content.Data]
			}
			if (costCenter) {
				return response.content.Data
			} else {
				if(obj && obj.type == 'web') {
					this.codeList = response.content.Data;
					this.total = response.content.TotalCount;
					return false;
				}
				if(this.pageIndex == 0) {
					this.costCenterList = [];
				}
				this.costCenterList = this.costCenterList.concat(response.content.Data);
				if(this.costCenterList.length == response.content.TotalCount) {
					this.allLoaded = true;
				}
				if (!response.content.Data.length) {
					this.noData = true
				}
				this.selected();
			}
		}
	}
	//字典查询
	async FnDictionaryQuery(params, type, obj) {
		let response = await this.api.post(this.url.dictionary.paging, params);
		if(response && response.success) {
			if(this.pageIndex == 1) {
				this.costCenterList = [];
			}
			this.costCenterList = this.costCenterList.concat(response.content.rows);
			if(this.costCenterList.length == response.content.total) {
				this.allLoaded = true;
			}
			this.selected();
		}
	}
	SearchCostCenterList (obj) {
		this.keyword = obj.keyword
		this.getCostCenter(obj)
	}
	SearchWbsList (obj) {
		this.keyword = obj.keyword
		this.getWBSCode(obj)
	}
}

export default costCenterSelector;



// WEBPACK FOOTER //
// ../scripts/components/costCenterSelector.js